import script from "./TermsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsView.vue?vue&type=script&lang=ts&setup=true"

import "./TermsView.vue?vue&type=style&index=0&id=14fbfefe&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fbfefe"]])

export default __exports__